import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";

import {
  GET_ORG_GROUP_SELECT,
SG_GET_ORG_GROUP_SELECT,
  SG_GET_ORG_GROUP_MEMBERS,
  GET_ORG_GROUP_MEMBERS,
  EMPLOYEE_GROUPS_PENDING,
  GET_ORG_GROUPS,
  SG_GET_ORG_GROUPS,
  FETCH_ORG_GROUP,
  SG_FETCH_ORG_GROUP,
  ADD_ORG_GROUP,
  SG_ADD_ORG_GROUP,
  UPDATE_ORG_GROUP,
  SG_UPDATE_ORG_GROUP,
  DELETE_ORG_GROUP,
  SG_DELETE_ORG_GROUP,
  BULK_ADD_ORG_GROUP_MEMBERS,
  SG_BULK_ADD_ORG_GROUP_MEMBERS,
  BULK_REMOVE_ORG_GROUP_MEMBERS,
  SG_BULK_REMOVE_ORG_GROUP_MEMBERS,
  ORG_GROUPS_PENDING,
} from "constants/actions";
import { handleError } from "./ApiError";

function* getOrgGroupSelectSaga(action) {
  try {
    const res = yield call(api.GET_ORG_GROUP_SELECT, action.payload);
    yield put({ type: GET_ORG_GROUP_SELECT, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* getOrgGroupMembersSaga(action) {
  try {
    const res = yield call(api.GET_ORG_GROUP_MEMBERS, action.payload);
    yield put({ type: GET_ORG_GROUP_MEMBERS, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

// Organization Group Sagas
function* getOrgGroupsSaga(action) {
  try {
    const res = yield call(api.GET_ORG_GROUPS, action.payload);
    yield put({ type: GET_ORG_GROUPS, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* fetchOrgGroupSaga(action) {
  try {
    const res = yield call(api.FETCH_ORG_GROUP, action.payload);
    yield put({ type: FETCH_ORG_GROUP, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* addOrgGroupSaga(action) {
  try {
    const res = yield call(api.ADD_ORG_GROUP, action.payload);
    yield put({ type: ADD_ORG_GROUP, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* updateOrgGroupSaga(action) {
  try {
    const res = yield call(api.UPDATE_ORG_GROUP, action.payload);
    yield put({ type: UPDATE_ORG_GROUP, payload: res.data });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* deleteOrgGroupSaga(action) {
  try {
    yield call(api.DELETE_ORG_GROUP, action.payload);
    yield put({ type: DELETE_ORG_GROUP, payload: action.payload });
  } catch (err) {
   yield call(handleError, err);
  }
}

function* bulkAddOrgGroupMembersSaga(action) {
  yield put({ type: ORG_GROUPS_PENDING });
  try {
    const res = yield call(api.BULK_ADD_ORG_GROUP_MEMBERS, action.payload);
    yield put({ type: BULK_ADD_ORG_GROUP_MEMBERS, payload: res.data });
    // Refresh the members list after successful add
    yield put({ 
      type: SG_GET_ORG_GROUP_MEMBERS, 
      payload: { id: action.payload.id, organization_groups: action.payload.id } 
    });
  } catch (err) {
    yield put({ 
      type: BULK_ADD_ORG_GROUP_MEMBERS, 
      payload: { error: err.response?.data || { message: err.message } } 
    });
  }
}

function* bulkRemoveOrgGroupMembersSaga(action) {
  yield put({ type: ORG_GROUPS_PENDING });
  try {
    const res = yield call(api.BULK_REMOVE_ORG_GROUP_MEMBERS, action.payload);
    yield put({ type: BULK_REMOVE_ORG_GROUP_MEMBERS, payload: res.data });
    // Refresh the members list after successful removal
    yield put({ 
      type: SG_GET_ORG_GROUP_MEMBERS, 
      payload: { id: action.payload.id, organization_groups: action.payload.id } 
    });
  } catch (err) {
    yield put({ 
      type: BULK_REMOVE_ORG_GROUP_MEMBERS, 
      payload: { error: err.response?.data || { message: err.message } } 
    });
  }
}

export default function* groupsSaga() {
  yield takeLatest(SG_GET_ORG_GROUP_SELECT, getOrgGroupSelectSaga);
  yield takeLatest(SG_GET_ORG_GROUP_MEMBERS, getOrgGroupMembersSaga);
  yield takeLatest(SG_GET_ORG_GROUPS, getOrgGroupsSaga);
  yield takeLatest(SG_FETCH_ORG_GROUP, fetchOrgGroupSaga);
  yield takeLatest(SG_ADD_ORG_GROUP, addOrgGroupSaga);
  yield takeLatest(SG_UPDATE_ORG_GROUP, updateOrgGroupSaga);
  yield takeLatest(SG_DELETE_ORG_GROUP, deleteOrgGroupSaga);
  yield takeLatest(SG_BULK_ADD_ORG_GROUP_MEMBERS, bulkAddOrgGroupMembersSaga);
  yield takeLatest(SG_BULK_REMOVE_ORG_GROUP_MEMBERS, bulkRemoveOrgGroupMembersSaga);
}
